<template>
  <div id="border-radius-page" class="page-wrapper">
    <h1>Border Radius</h1>
    <section class="version-2">
      <!-- <h2>Version 2</h2> -->
      <div class="token-grid">
        <div v-for="(radius, name) in v2Tokens" :key="name" class="token-item">
          <div class="preview" :style="{ borderRadius: radius }"></div>
          <div class="token-info">
            <code>{{ name }}</code>
            <span>{{ radius }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      v1Tokens: {
        '$border-radius-none': '0px',
        '$border-radius-2xs': '4px',
        '$border-radius-xs': '8px',
        '$border-radius-sm': '12px',
        '$border-radius-md': '16px',
        '$border-radius-lg': '20px',
        '$border-radius-xl': '32px',
        '$border-radius-2xl': '48px',
        '$border-radius-pill': '999px',
        '$border-radius-circle': '50%'
      },
      v2Tokens: {
        '$radius-4xs': '2px',
        '$radius-3xs': '4px',
        '$radius-2xs': '6px',
        '$radius-xs': '8px',
        '$radius-sm': '12px',
        '$radius-md': '16px',
        '$radius-lg': '20px',
        '$radius-xl': '24px',
        '$radius-2xl': '32px',
        '$radius-3xl': '40px',
        '$radius-4xl': '48px',
        '$radius-pill': '999px',
        '$radius-circle': '999px'
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../lib/design-token/border-radius-token.scss';

#border-radius-page {
  display: flex;
  flex-direction: column;

  code {
    font-size: 14px !important;
    color: $color-cool-grey-700 !important;
  }

  section {
    h3 {
      margin-bottom: 1.5rem;
    }
  }

  .token-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  }

  .token-item {
    display: flex;
    flex-direction: column;
    gap: 12px;
    border: 1px solid $color-cool-grey-200;
    padding: 16px;
    border-radius: 8px;
    .preview {
      width: 100px;
      height: 100px;
      background-color: $color-cool-grey-100;
      border: 1px solid $color-cool-grey-200;
    }

    .token-info {
      display: flex;
      flex-direction: column;
      gap: 8px;

      code {
        font-family: monospace;
        color: $color-cool-grey-500;;
      }

      span {
        font-size: 14px;
        color: $color-cool-grey-500;
      }
    }
  }
}
</style>
